import { useModal } from "@racoon/ui";
import { Namespace, useT } from "@racoon/i18n";
import {
  AddPseudoJobsContent,
  AddPseudoJobsContentProps,
} from "../ui/components/add-pseudo-jobs.content";

export type OpenAddPseudoJobsOptions = Omit<AddPseudoJobsContentProps, "onClose">;

/**
 * Opens the "create new jobs" picker — pickup location → container groups →
 * job types. The picks are handed back through `onAdd`, which also closes it.
 */
export function useAddPseudoJobsModal() {
  const { openModal, closeModal } = useModal();
  const t = useT();

  const openAddPseudoJobs = (options: OpenAddPseudoJobsOptions) => {
    const id = openModal({
      size: "custom",
      width: { md: 1072 },
      title: (
        <span className="text-xl font-bold tracking-tight text-text-primary">
          {t(Namespace.Routes, "addPseudoJobsTitle")}
        </span>
      ),
      closeButtonTop: "top-5",
      headerClassName: "!p-4",
      // ModalHeader draws its own 0.1px separator, which is invisible;
      // this border is the line the design asks for.
      bodyClassName: "!p-0 border-t border-border-primary",
      body: <AddPseudoJobsContent {...options} onClose={() => closeModal(id)} />,
    });
    return id;
  };

  return { openAddPseudoJobs };
}
